import { RouteRecordRaw } from 'vue-router'

import { CS_DATE_ROUTE_NAMES } from '@/modules/csDate/constants/CSDateRouteNames'
import { todayIsoStr } from '@/utils/utils'

import { UserGroup } from '@generated/types'

function isValidISODate(dateStr: string): boolean {
  // Expect YYYY-MM-DD and ensure month/day are valid
  const m = /^\d{4}-\d{2}-\d{2}$/.exec(dateStr)
  if (!m) return false
  const [y, mo, d] = dateStr.split('-').map(Number)
  const dt = new Date(Date.UTC(y, mo - 1, d))
  const yyyy = dt.getUTCFullYear()
  const mm = dt.getUTCMonth() + 1
  const dd = dt.getUTCDate()
  // Reconstruct to compare (zero-pad)
  const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`)
  return yyyy === y && mm === mo && dd === d && `${y}-${pad(mo)}-${pad(d)}` === dateStr
}

export const CSDateRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/continuous-service/',
    redirect: {
      name: CS_DATE_ROUTE_NAMES.LAYOUT,
      params: { csAreaId: 0, date: todayIsoStr() },
    },
    name: CS_DATE_ROUTE_NAMES.ROOT,
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Continuous Reservations',
    },
    children: [
      {
        path: ':csAreaId(\\d+)/:date',
        component: () => import('@/modules/csDate/layouts/CSDateLayout.vue'),
        props: route => ({
          csAreaId: +route.params.csAreaId,
          date: String(route.params.date),
        }),
        beforeEnter: (to, _, next) => {
          const date = String(to.params.date)
          if (!isValidISODate(date)) return next({ name: 'not-found' })
          return next()
        },
        children: [
          {
            path: '',
            name: CS_DATE_ROUTE_NAMES.LAYOUT,
            redirect: { name: CS_DATE_ROUTE_NAMES.RESERVATION_LIST },
          },
          {
            path: 'configure',
            name: CS_DATE_ROUTE_NAMES.CONFIGURE,
            component: () => import('@/modules/csDate/pages/CSDateConfigure.vue'),
            meta: { pageTitle: 'Continuous Reservations - Configure' },
          },
          {
            path: 'reservations',
            children: [
              {
                path: '',
                name: CS_DATE_ROUTE_NAMES.RESERVATION_LIST,
                component: () => import('@/modules/csDate/pages/CSReservationList.vue'),
                meta: { pageTitle: 'Continuous Reservations - Reservation List' },
              },
              {
                path: ':reservationId(\\d+)',
                children: [
                  {
                    path: '',
                    name: CS_DATE_ROUTE_NAMES.RESERVATION_DETAIL,
                    component: () => import('@/modules/csDate/pages/CSReservationDetail.vue'),
                    props: route => ({ reservationId: +route.params.reservationId }),
                    meta: { pageTitle: 'Continuous Reservations - Reservation Detail' },
                  },
                  {
                    path: 'edit',
                    name: CS_DATE_ROUTE_NAMES.RESERVATION_EDIT,
                    component: () => import('@/modules/csDate/pages/CSReservationEdit.vue'),
                    props: route => ({ reservationId: +route.params.reservationId }),
                    meta: { pageTitle: 'Continuous Reservations - Reservation Edit' },
                  },
                ],
              },
              {
                path: 'reserve',
                name: CS_DATE_ROUTE_NAMES.RESERVATION_CREATE,
                component: () => import('@/modules/csDate/pages/CSReservationCreate.vue'),
                meta: { pageTitle: 'Continuous Reservations - Reserve' },
              },
            ],
          },
        ],
      },
    ],
  },
]
